/**
 * VendorPortalProductAddOnService
 * Service for vendor product add-on management.
 * Route: api/vendor-portal/add-ons
 */
import { VendorPortalBaseService } from './VendorPortalBaseService';
/**
 * VendorPortalProductAddOnService
 * Handles vendor product add-on operations for the vendor portal.
 * Maps to /api/vendor-portal/add-ons endpoint
 */
export class VendorPortalProductAddOnService extends VendorPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPortalProductAddOnService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? VendorPortalProductAddOnService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL ====================
    /**
     * Get all add-ons for the authenticated vendor
     * GET /api/vendor-portal/add-ons
     */
    async getAddOns() {
        const response = await this.getAddOnsRaw();
        return response.data ?? [];
    }
    /**
     * Get all add-ons (raw response)
     */
    getAddOnsRaw() {
        return this.get();
    }
    // ==================== GET BY ID ====================
    /**
     * Get a specific add-on by ID
     * GET /api/vendor-portal/add-ons/{id}
     */
    async getAddOn(id) {
        const response = await this.getAddOnRaw(id);
        if (!response.data) {
            throw new Error(`Add-on with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get a specific add-on (raw response)
     */
    getAddOnRaw(id) {
        return this.get(`${id}`);
    }
    // ==================== GET BY PRODUCT ====================
    /**
     * Get all add-ons for a specific product
     * GET /api/vendor-portal/add-ons/by-product/{productId}
     */
    async getByProductId(productId) {
        const response = await this.getByProductIdRaw(productId);
        return response.data ?? [];
    }
    /**
     * Get add-ons by product ID (raw response)
     */
    getByProductIdRaw(productId) {
        return this.get(`by-product/${productId}`);
    }
    // ==================== CREATE ====================
    /**
     * Create a new add-on
     * POST /api/vendor-portal/add-ons
     */
    async createAddOn(data) {
        const response = await this.createAddOnRaw(data);
        if (!response.data) {
            throw new Error('Failed to create add-on');
        }
        return response.data;
    }
    /**
     * Create a new add-on (raw response)
     */
    createAddOnRaw(data) {
        return this.post('', data);
    }
    // ==================== UPDATE ====================
    /**
     * Update an existing add-on
     * PUT /api/vendor-portal/add-ons/{id}
     */
    async updateAddOn(id, data) {
        const response = await this.updateAddOnRaw(id, data);
        if (!response.data) {
            throw new Error(`Failed to update add-on with ID ${id}`);
        }
        return response.data;
    }
    /**
     * Update an existing add-on (raw response)
     */
    updateAddOnRaw(id, data) {
        return this.put(`${id}`, data);
    }
    // ==================== DELETE ====================
    /**
     * Delete an add-on
     * DELETE /api/vendor-portal/add-ons/{id}
     */
    async deleteAddOn(id) {
        const response = await this.deleteAddOnRaw(id);
        return response.success;
    }
    /**
     * Delete an add-on (raw response)
     */
    deleteAddOnRaw(id) {
        return this.delete(`${id}`);
    }
}
VendorPortalProductAddOnService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorPortalProductAddOnService.BASE_PATH = 'api/vendor-portal/add-ons';
//# sourceMappingURL=VendorPortalProductAddOnService.js.map